import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ListItemModel, SearchUserModel } from '../../core/services/api-services';
import { UserService } from '../../core/services/api-services';

@Component({
    selector: 'app-user-autocomplete',
    templateUrl: './user-autocomplete.component.html',
    styleUrls: ['./user-autocomplete.component.scss'],
    standalone: false
})
export class UserAutocompleteComponent {
  @Input() itemControl!: FormControl;
  @Input() label!: string;
  @Input() infoText: string | null = null;
  @Input() error: string | null = null;
  @Input() isWeibel: boolean | null = null;
  @Input() isGuide: boolean | null = null;
  @Input() coOrganizer: boolean | null = null;
  @Input() visitRequestInvitationId: string | null = null;
  @Input() excludeIds: string[] | null = null;
  @Input() minCharacters: number = 0;
  @Output() selected = new EventEmitter<ListItemModel>();

  constructor(private readonly userService: UserService) { }

  search = (value: string | null) => {
    return this.userService.search({
      id: null,
      searchText: value,
      isWeibel: this.isWeibel,
      isGuide: this.isGuide,
      coOrganizer: this.coOrganizer,
      visitRequestInvitationId: this.visitRequestInvitationId,
      excludeIds: this.excludeIds
    } as SearchUserModel);
  }

  getItemName = (item: any) => {
    return (item as ListItemModel)?.name;
  }

  onSelected(value: any) {
    this.selected.emit(value);
  }
}
